import { type StepWizardChildProps } from 'react-step-wizard'

import {
    VerificationFooter,
    VerificationUplaodImagesContent
} from 'components-ref/organisms/verification'
import { useUserProfile } from 'store'

import { VerificationContainer } from '../VerificationCountry/VerificationCountry'

export function VerificationUploadImages({
    currentStep,
    previousStep,
    nextStep
}: Partial<StepWizardChildProps>) {
    const userData = useUserProfile()
    return (
        <VerificationContainer>
            <VerificationUplaodImagesContent hideUpload={false} />
            <VerificationFooter
                currentStep={currentStep}
                previousStep={previousStep}
                nextStep={nextStep}
                nextDisabled={!userData?.cover?.url || !userData?.avatar?.url}
            />
        </VerificationContainer>
    )
}
